'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _KeepInMind = require('shared/components/KeepInMind');

exports.default = _KeepInMind.KeepInMind;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/KeepInMind/index.js
// module id = 1214
// module chunks = 0